import { getRequest, postRequest } from './api'

export async function list(size, index, searchTerm, orderBy) {
  return getRequest(
    `costTypeDefinition/get-list/${size || 15}/${index || 0}/${searchTerm || '%20'}/${orderBy ||
      '%20'}`,
  )
}

export async function find(id) {
  return getRequest(`costTypeDefinition/edit/${id}`)
}

export async function save(values) {
  return postRequest(`costTypeDefinition/save`, values)
}

export function remove(values) {
  return postRequest(`costTypeDefinition/delete`, values)
}
